<template>
  <div id="PcrfHistoryTable">
    <div v-if="noPcrfHistory" class="container">
      <div class="section" style="padding-top: 3rem !important">
        <p class="subtitle is-6" style="color: #8c8c8c;">{{ noPcrfHistory }}</p>
      </div>
    </div>
    <div v-else class="container">
      <!-- Prospect Customer List -->
      <b-table :data="pcrfHistoryList" :striped="true">
        <template slot-scope="props">
          <!-- Created Date -->
          <b-table-column
            field="create_date"
            :label="$t('customer.tabs.table.created')"
            >{{ props.row.create_date | dateformatter }}</b-table-column
          >
          <!-- Cell Name -->
          <b-table-column
            field="cell_name"
            :label="$t('customer.detail.location')"
            >{{ props.row.cell_name }}</b-table-column
          >
          <!-- Cell Info. -->
          <b-table-column field="cgi" label="CGI">{{
            props.row.cell_info.cgi
          }}</b-table-column>
          <b-table-column field="cid" label="CID">{{
            props.row.cell_info.cid
          }}</b-table-column>
          <b-table-column field="lac" label="LAC">{{
            props.row.cell_info.lac
          }}</b-table-column>
          <!-- Cell Location (lat , lng) -->
          <b-table-column field="location" :label="$t('site.cell.location')"
            >{{ props.row.latitude | todecimal(6) }},{{
              props.row.longitude | todecimal(6)
            }}</b-table-column
          >
          <!-- Distance between Cell and customer-->
          <b-table-column field="distance" :label="$t('site.distance')">{{
            props.row.distance | todecimal(2)
          }}</b-table-column>
          <!-- PCRF Status-->
          <b-table-column
            field="action"
            :label="$t('customer.tabs.table.action')"
          >
            <span
              v-if="props.row.action === 'in_area'"
              class="tag is-success"
              >{{ props.row.action }}</span
            >
            <span
              v-else-if="props.row.action === 'out_area'"
              class="tag is-danger"
              >{{ props.row.action }}</span
            >
            <span v-else class="tag is-warning"> N/A </span>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "PcrfHistoryTable",
  props: ["customer_id", "enable"],
  data() {
    return {
      noPcrfHistory: null,
      pcrfHistoryList: []
    };
  },
  watch: {
    enable: function(val) {
      if (val) this.getPcrfHistory();
    }
  },
  filters: {
    todecimal: function(value, decimal_place) {
      if (!value) return "";
      return Number(value).toFixed(decimal_place);
    },
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    getPcrfHistory: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const pcrfHistoryResult = await CustomerApiManager.requestPcrfHistory(
        this.customer_id
      );
      loadingComponent.close();

      switch (pcrfHistoryResult.code) {
        case "0":
          if (pcrfHistoryResult.data.pcrf_history.length > 0) {
            this.noPcrfHistory = null;
            this.pcrfHistoryList = pcrfHistoryResult.data.pcrf_history;
          } else {
            this.noPcrfHistory = this.$t(
              "customer.tabs.table.pcrf_history.not_found"
            );
          }
          break;

        default:
          AlertManager.showErrorSnackbar(pcrfHistoryResult.message);
          break;
      }
    }
  },
  mounted() {
    if (this.enable) this.getPcrfHistory();
  }
};
</script>

<style></style>
